export const blockIconsTravelCarRentalNew = (
	<span className='material-symbols-outlined'>car_rental</span>
);
